export const PAGE_LIKES = 'page_likes'
